import React, { useEffect, useState } from 'react';
import Icon from './Icon';
import { getTheme, toggleTheme, initTheme } from './theme';

// Light/dark switch. Renders the icon of the theme you'll switch *to*.
export default function ThemeToggle({ compact = false, className = '' }) {
  const [theme, setThemeState] = useState(getTheme());

  useEffect(() => { initTheme(); }, []);

  const onClick = () => setThemeState(toggleTheme());
  const goingLight = theme === 'dark'; // clicking will switch to light

  return (
    <button
      type="button"
      className={`theme-toggle ${className}`}
      onClick={onClick}
      title={goingLight ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-label="Toggle color theme"
    >
      <Icon name={goingLight ? 'sun' : 'moon'} size={16} />
      {!compact && <span>{goingLight ? 'Light' : 'Dark'}</span>}
    </button>
  );
}
